<div class="workflows-page">
  <ui-page-header [title]="'workflows.title' | translate" [lucideIcon]="'Zap'"></ui-page-header>

  <nav class="workflows-tabs" [attr.aria-label]="'workflows.tabs.nav_label' | translate">
    <button
      type="button"
      class="workflows-tabs__tab"
      [class.workflows-tabs__tab--active]="mainTab === 'rules'"
      (click)="setMainTab('rules')"
    >
      {{ 'workflows.tabs.rules' | translate }}
    </button>
    <button
      type="button"
      class="workflows-tabs__tab"
      [class.workflows-tabs__tab--active]="mainTab === 'history'"
      (click)="setMainTab('history')"
    >
      {{ 'workflows.tabs.history' | translate }}
    </button>
  </nav>

  <div class="workflows-content" *ngIf="mainTab === 'rules'">
    <div class="workflows-toolbar">
      <ui-form-field
        class="workflows-toolbar__search"
        [formControl]="searchControl"
        [placeholder]="'workflows.toolbar.search_placeholder' | translate"
        suffixIcon="search-cc"
        type="text"
      >
      </ui-form-field>
      <div class="workflows-toolbar__buttons">
        <ng-container *appHasPermission="{ module: 'workflow', action: 'create' }">
          <ui-button
            type="primary"
            [label]="'workflows.toolbar.new_rule' | translate"
            icon="plus-cc"
            iconSize="large"
            (click)="createRule()"
          >
          </ui-button>
        </ng-container>
      </div>
    </div>

    <ng-container *ngIf="loading$ | async">
      <p class="workflows-status">{{ 'workflows.rules.loading' | translate }}</p>
    </ng-container>

    <ng-container *ngIf="loadError$ | async">
      <p class="workflows-status workflows-status--error" role="alert">
        {{ 'workflows.rules.load_error' | translate }}
      </p>
    </ng-container>

    <ng-container *ngIf="(loading$ | async) === false && (loadError$ | async) === false">
      <ng-container *ngIf="listVm$ | async as vm">
        <div class="workflows-sections">
          <section class="workflows-section">
            <div class="workflows-section__header">
              <h2 class="workflows-section__title">
                {{ 'workflows.rules.active_section' | translate }}
                <span class="workflows-section__title-count">{{ vm.active.length }}</span>
              </h2>
              <ui-button
                class="workflows-section__toggle"
                type="secondary"
                [icon]="activeSectionOpen ? 'chevron-up' : 'chevron-down'"
                (click)="activeSectionOpen = !activeSectionOpen"
              >
              </ui-button>
            </div>

            <ng-container *ngIf="activeSectionOpen">
              <ul
                *ngIf="vm.active.length"
                class="rule-list"
                [attr.aria-label]="'workflows.rules.list_label' | translate"
              >
                <li *ngFor="let rule of vm.active; trackBy: trackByRuleId" class="rule-row">
                  <span class="rule-row__icon">
                    <ui-svg-icon [svgIcon]="categoryIcon(rule.triggerType)" size="medium"></ui-svg-icon>
                  </span>
                  <div class="rule-row__main">
                    <h3 class="rule-row__name">{{ rule.name }}</h3>
                    <p class="rule-row__preview" *ngIf="rule.preview">{{ rule.preview }}</p>
                  </div>
                  <div class="rule-row__right">
                    <div class="rule-row__meta">
                      <span class="rule-row__trigger">{{ triggerLabelKey(rule.triggerType) | translate }}</span>
                      <span class="rule-row__stats">
                        {{ 'workflows.rules.runs_count' | translate: { count: rule.timesRun } }}
                        <span *ngIf="rule.lastRunAt"> · {{ 'workflows.rules.last_fired' | translate: { when: (rule.lastRunAt | daysAgoOrLeft: 'ago') } }}</span>
                        <span *ngIf="!rule.lastRunAt"> · {{ 'workflows.rules.last_fired_never' | translate }}</span>
                      </span>
                    </div>
                    <ng-container *appHasPermission="{ module: 'workflow', action: 'edit' }">
                      <mat-slide-toggle
                        [checked]="isRuleUiEnabled(rule)"
                        (change)="onRuleToggle(rule, $event.checked)"
                        [attr.aria-label]="'workflows.rules.toggle_label' | translate: { name: rule.name }"
                      ></mat-slide-toggle>
                    </ng-container>
                    <ui-button
                      *ngIf="canEditOrDelete$ | async"
                      type="transparent"
                      class="rule-row__menu-btn"
                      [matMenuTriggerFor]="ruleActionsMenu"
                      (click)="ruleMenuContext = rule"
                      [attr.aria-label]="'workflows.rules.more_actions' | translate"
                      icon="more_vert"
                      iconSize="medium"
                    >
                    </ui-button>
                  </div>
                </li>
              </ul>
              <p *ngIf="!vm.active.length" class="workflows-empty">{{ 'workflows.rules.empty_active' | translate }}</p>
            </ng-container>
          </section>

          <section class="workflows-section">
            <div class="workflows-section__header">
              <h2 class="workflows-section__title">{{ 'workflows.rules.inactive_section' | translate }} <span class="workflows-section__title-count">{{ vm.inactive.length }}</span></h2>
              <ui-button
                class="workflows-section__toggle"
                type="secondary"
                [icon]="inactiveSectionOpen ? 'chevron-up' : 'chevron-down'"
                (click)="inactiveSectionOpen = !inactiveSectionOpen"
              >
              </ui-button>
            </div>

            <ng-container *ngIf="inactiveSectionOpen">
              <ul *ngIf="vm.inactive.length" class="rule-list">
                <li *ngFor="let rule of vm.inactive; trackBy: trackByRuleId" class="rule-row rule-row--muted">
                  <span class="rule-row__icon">
                    <ui-svg-icon [svgIcon]="categoryIcon(rule.triggerType)" size="medium"></ui-svg-icon>
                  </span>
                  <div class="rule-row__main">
                    <h3 class="rule-row__name">{{ rule.name }}</h3>
                    <p class="rule-row__preview" *ngIf="rule.preview">{{ rule.preview }}</p>
                  </div>
                  <div class="rule-row__right">
                    <div class="rule-row__meta">
                      <span class="rule-row__trigger">{{ triggerLabelKey(rule.triggerType) | translate }}</span>
                      <span class="rule-row__stats">
                        {{ 'workflows.rules.runs_count' | translate: { count: rule.timesRun } }}
                        <span *ngIf="rule.lastRunAt"> · {{ 'workflows.rules.last_fired' | translate: { when: (rule.lastRunAt | daysAgoOrLeft: 'ago') } }}</span>
                        <span *ngIf="!rule.lastRunAt"> · {{ 'workflows.rules.last_fired_never' | translate }}</span>
                      </span>
                    </div>
                    <ng-container *appHasPermission="{ module: 'workflow', action: 'edit' }">
                      <mat-slide-toggle
                        [checked]="isRuleUiEnabled(rule)"
                        (change)="onRuleToggle(rule, $event.checked)"
                        [attr.aria-label]="'workflows.rules.toggle_label' | translate: { name: rule.name }"
                      ></mat-slide-toggle>
                    </ng-container>
                    <ui-button
                      *ngIf="canEditOrDelete$ | async"
                      type="transparent"
                      class="rule-row__menu-btn"
                      [matMenuTriggerFor]="ruleActionsMenu"
                      (click)="ruleMenuContext = rule"
                      [attr.aria-label]="'workflows.rules.more_actions' | translate"
                      icon="more_vert"
                      iconSize="medium"
                    >
                    </ui-button>
                  </div>
                </li>
              </ul>
              <p *ngIf="!vm.inactive.length" class="workflows-empty">{{ 'workflows.rules.empty_inactive' | translate }}</p>
            </ng-container>
          </section>
        </div>

        <mat-menu #ruleActionsMenu="matMenu">
          <button mat-menu-item
            *appHasPermission="{ module: 'workflow', action: 'edit' }"
            (click)="ruleMenuContext && editRule(ruleMenuContext)">{{ 'workflows.rules.menu.edit' | translate }}</button>
          <button mat-menu-item
            *appHasPermission="{ module: 'workflow', action: 'delete' }"
            (click)="ruleMenuContext && deleteRule(ruleMenuContext)">{{ 'workflows.rules.menu.delete' | translate }}</button>
        </mat-menu>
      </ng-container>
    </ng-container>
  </div>

  <div *ngIf="mainTab === 'history'" class="workflows-content workflows-content--history">
    <div class="workflows-toolbar workflows-toolbar--history">
      <ui-form-field
        class="workflows-toolbar__search"
        [formControl]="historySearchControl"
        [placeholder]="'workflows.history.filters.search_placeholder' | translate"
        suffixIcon="search-cc"
        type="text"
      >
      </ui-form-field>

      <ui-form-field
        class="workflows-toolbar__status"
        [formControl]="historyStatusControl"
        [options]="historyStatusOptions"
        type="select"
      >
      </ui-form-field>
    </div>

    <ng-container *ngIf="historyLoading">
      <p class="workflows-status">{{ 'workflows.history.loading' | translate }}</p>
    </ng-container>

    <ng-container *ngIf="historyLoadError">
      <div class="workflows-history__error">
        <p class="workflows-status workflows-status--error" role="alert">
          {{ 'workflows.history.load_error' | translate }}
        </p>
        <ui-button
          type="secondary"
          [label]="'workflows.history.retry' | translate"
          (click)="setMainTab('history')"
        >
        </ui-button>
      </div>
    </ng-container>

    <ng-container *ngIf="!historyLoading && !historyLoadError">
      <div *ngIf="historyExecutions.length; else historyEmptyState" class="workflows-history-table" [attr.aria-label]="'workflows.history.table_label' | translate">
        <div class="workflows-history-table__head">
          <span>{{ 'workflows.history.columns.time' | translate }}</span>
          <span>{{ 'workflows.history.columns.rule_name' | translate }}</span>
          <span>{{ 'workflows.history.columns.url' | translate }}</span>
          <span>{{ 'workflows.history.columns.actions' | translate }}</span>
          <span>{{ 'workflows.history.columns.status' | translate }}</span>
        </div>

        <div class="workflows-history-table__body" (scroll)="onHistoryScroll($event)">
          <div class="workflows-history-table__row" *ngFor="let execution of historyExecutions; trackBy: trackByExecutionId">
            <span class="workflows-history-table__time">
              {{ execution.executedAt | daysAgoOrLeft: 'ago' : 2 : 'DD/MM/YYYY HH:mm' }}
            </span>
            <span class="workflows-history-table__rule">{{ execution.ruleName || '--' }}</span>
            <span class="workflows-history-table__url">
              <ng-container *ngIf="historyTargetUrl(execution) as targetUrl; else noTarget">
                <a
                  [href]="targetUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="workflows-history-table__url-link"
                >
                  {{ historyTargetLabel(execution) || targetUrl }}
                </a>
              </ng-container>
              <ng-template #noTarget>--</ng-template>
            </span>
            <span class="workflows-history-table__actions">{{ historyActionsCount(execution) }}</span>
            <span class="workflows-history-table__status" [ngClass]="historyStatusClass(execution.status)">
              {{ statusLabelKey(execution.status) | translate }}
            </span>
          </div>

          <div class="workflows-history-table__loading-more" *ngIf="historyLoadingMore">
            <span>{{ 'workflows.history.loading' | translate }}</span>
          </div>
        </div>
      </div>

      <ng-template #historyEmptyState>
        <p class="workflows-placeholder">
          {{
            (hasActiveHistoryFilters()
              ? 'workflows.history.empty_filtered'
              : 'workflows.history.placeholder') | translate
          }}
        </p>
      </ng-template>
    </ng-container>
  </div>
</div>
